export default function MarketingData() {
    return [
        {
            text: [
                {
                    title: "What is Hospital Insurance?",
                    paragraphs: ["Hospital Insurance pays cash benefits to help cover the added expenses that may occur while you recover."],
                }
            ],
            image: "/product-landing/hosp/circle2.png"
        },
        {
            text: [
                {
                    title: "Apply in Minutes. Get a Decision in Days.",
                    paragraphs: ["Submit your application now and get a decision in 1-2 days. With many supplemental coverage options taking weeks or months, this is one of the fastest and most efficient ways to secure coverage."],
                }
            ],
            image: "/product-landing/hosp/circle3.png"
        },
        {
            text: [
                {
                    title: "The Right Coverage for You",
                    paragraphs: ["With hospital insurance, you can get the coverage you need, with rates that fit most budgets - often without a medical exam."],
                }
            ],
            image: "/product-landing/hosp/circle4.png"
        }
    ]
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/Hospital/MarketingData.js